import { IPROP_MAP, modifyProps } from '../../generators/modifyProps';

import { AvatarProps } from '../jdsavatar/logic';
import { IconProps } from '../jdsicon/logic';
import { JDSAccordionProps } from './generated';
import { ListBlockProps } from '../jdslistblock/logic';
import { ReactNode } from 'react';
import { convertTextToComponent } from '../../utils/componenthelpers';
import { useRootRef } from '../../hooks/useRootRef';

interface AccordionHeaderProps {
  title: string;
  subtitle?: string;
  prefix?: React.ReactElement<AvatarProps | IconProps>;
}

export interface AccordionPanelProps
  extends JDSAccordionProps,
    Omit<AccordionHeaderProps, 'title' | 'prefix'> {
  iconType?: 'chevron' | 'plus';
  onClick?: React.MouseEventHandler;
  expandedPanel?: boolean;
  disabled?: boolean;
  children?: ReactNode;
  /**
   * @deprecated
   * Use `title`, `subtitle` and `prefix` props
   */
  header?: string | ListBlockProps;
}

export const PROP_MAP: IPROP_MAP<AccordionPanelProps> = (props) => {
  return {
    header: {
      properties: {
        title:
          props.title ||
          (props.header as AccordionHeaderProps)?.title ||
          (props.header as ListBlockProps)?.titleBlock?.text ||
          props.header,
        subtitle:
          props.subtitle ||
          (props.header as ListBlockProps)?.titleBlock?.helper,
        prefix: props.prefix || (props.header as ListBlockProps)?.prefix
      }
    },
    children: {
      properties: {
        children: convertTextToComponent(props.children)
      }
    }
  };
};

export const withLogic =
  (
    Component: React.ComponentType<AccordionPanelProps>
  ): React.FC<AccordionPanelProps> =>
  (userProps: AccordionPanelProps) => {
    const props = modifyProps(userProps, PROP_MAP);
    const { element, rootRef } = useRootRef();
    const childContainer = element?.querySelector<HTMLDivElement>(
      'div#child-content-container'
    );
    return (
      <Component
        {...{
          ...props,
          rootRef,
          _ariaControls: 'children-container',
          _childrenHeight: props.expandedPanel
            ? Math.max(
                element?.offsetHeight || 0,
                (childContainer?.offsetHeight || 0) + 16
              )
            : 0
        }}
      />
    );
  };
